'use client';
import React from 'react';
import FooterlLinkLists from './FooterlLinkLists';
import { platformDomainSelector } from '@/app/services/ArticleService';

const platform = process.env.NEXT_PUBLIC_PLATFORM;
const baseDomain = platformDomainSelector(platform);

const LegalList = [
  {
    title: 'Privacy Policy',
    link: `${baseDomain}/policy/privacyPolicy.html`,
  },
  {
    title: 'Refund & Cancellation Policy',
    link: `${baseDomain}/policy/refundAndCancellationPolicy.html`,
  },
  {
    title: 'Terms & Conditions',
    link: `${baseDomain}/policy/termsAndConditions.html`,
  },
  {
    title: 'Disclaimer',
    link: `${baseDomain}/policy/disclaimerPolicy.html`,
  },
];

const FooterLegal = () => {
  const filteredLegalList =
    platform === 'paBlog'
      ? LegalList.filter((item) => item.title !== 'Disclaimer')
      : LegalList;

  return (
    <section className='max-sm:w-[60%]'>
      <h2 className='mb-[25px]  text-[16px] font-medium text-[#fff]'>Legal</h2>
      <FooterlLinkLists data={filteredLegalList} targetBlank />
    </section>
  );
};

export default FooterLegal;
